async function devtricker_fetch_user_posts_stats() {
    try {
        const url = new URL('/wp-admin/admin-ajax.php', window.location.origin);
        url.searchParams.append('action', 'devtricker_action_get_user_posts_stats_ajax');

        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin'
        });

        const result = await response.json();

        if (result.error) {
            console.error('Error fetching user posts stats:', result.error);
            return null;
        }

        console.log('User posts stats:', result);
        return result;
    } catch (error) {
        console.error('Failed to fetch user posts stats:', error);
        return null;
    }
}